import { Grid2, Typography } from '@mui/material';
import { InputField } from '../FormFields';

const SearchUserForm = () => {
  return (
    <>
      <Typography variant="h6" align="center" gutterBottom>
        Search for a User
      </Typography>
      <Grid2 container spacing={3} alignItems="center" justifyContent="center">
        <Grid2 size={{ xs: 12, sm: 6 }}>
          <InputField
            name="userName"
            label="Username*"
            textFieldType="text"
            fullWidth
          />
        </Grid2>
      </Grid2>
    </>
  );
};

export default SearchUserForm;
